import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Button, Row, Col, Form } from "react-bootstrap";
import { getApi, postApi } from "./axiosInstance/axiosConfig";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default function GrossProfit() {
  const [GrossProfit, setGrossProfit] = useState("");
  const [OvernightGross, setOvernightGross] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const grossProfit = {
      grossProfit: parseFloat(GrossProfit),
      overnightGrossProfit: parseFloat(OvernightGross),
    };

    try {
      const response = await postApi("insertProfit", grossProfit);
      if (response?.status) {
        const data = await response.data;
        console.log(data);
        toast.success("Edit Successful", {
          autoClose: 100, // Display toast for 3 seconds
        });
      } else {
        setSubmitting(false);
        toast.error(response);
      }
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      setError("There was an error submitting the form!");
    }
    finally{
      setSubmitting(false);
    }
  };
  useEffect(() => {
    getApi("getProfit")
      .then((res) => {
        console.log(res.data);
        setGrossProfit(res.data.grossProfit);
        setOvernightGross(res.data.overnightGrossProfit);
      })
      .catch((err) => {
        console.log(err, "errorr here");
        setError(err.message);
        setLoading(false);
      });
  }, []);
  return (
    <React.Fragment>
      <Card>
        <Card.Header className="py-4">
          <h5>Gross Profit</h5>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col lg={6}>
                <Form.Group className="form-group mb-3">
                  <Form.Label>Gross Profit</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Gross Profit"
                    value={GrossProfit}
                    onChange={(e) => setGrossProfit(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="form-group mb-3">
                  <Form.Label>Overnight Gross Profit</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Overnight Gross Profit"
                    value={OvernightGross}
                    onChange={(e) => setOvernightGross(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Button
              type="submit"
              className="btn btn-primary px-4 mt-3 min_width140"
              disabled={submitting}
            >
              Update
            </Button>
          </Form>
        </Card.Body>
      </Card>
      <ToastContainer />
    </React.Fragment>
  );
}
